import { PickingTaskGenerateByLocationGroupPage } from "@/features/picking-task/pages/PickingTaskGenerateByLocationGroupPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/picking-task/$id/create-location-group",
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["picking_task.generate"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PickingTaskGenerateByLocationGroupPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      warehouseLocationGroupID: search.warehouseLocationGroupID as string,
      warehouseLocationGroupName: search.warehouseLocationGroupName as string,
    };
  },
});
